import { rem, rgba } from "polished";
const defaultOutline = (color) => (color === "transparent" ? "none" : `0 0 0 ${rem(3)} ${rgba(color, 0.3)}`); // TODO shade 200
export function createShadow(shadow, outline = defaultOutline) {
    const values = Object.assign({ sm: "0 2px 4px 0 rgba(0, 0, 0, .1)", md: "0 5px 25px 0 rgba(0, 0, 0, .1)", lg: "0 20px 25px -5px rgba(0, 0, 0, .1), 0 10px 10px -5px rgba(0, 0, 0, .05)" }, shadow);
    return {
        outline,
        shadow: (key) => values[key],
    };
}
export default createShadow;
//# sourceMappingURL=create-shadow.js.map